import cart1 from "@assets/images/cart1.svg";
import cart2 from "@assets/images/cart2.svg";
import { Paper } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import MyTypography from "@saleor/components/MyTypography";
import { CustomerCartTotalsQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { RelayToFlatNoEdge } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

interface ICartInfo {
  data: RelayToFlatNoEdge<CustomerCartTotalsQuery["customerCartTotals"]>;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      padding: "1.6rem 2.4rem",
      display: "flex",
      borderRadius: 6,
      marginBottom: 16,
      boxShadow: "none"
    },
    left: {
      width: "80%"
    },
    right: {
      width: "20%",
      background: "rgba(0, 159, 184, 0.1)",
      borderRadius: 4,
      position: "relative",

      "& img": {
        position: "absolute",
        margin: "auto",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    },
    title: {
      color: theme.palette.grey[700]
    },
    subtitle: {
      paddingBottom: 16,
      color: theme.palette.grey[700]
    },
    totalNumber: {
      color: theme.palette.grey[800]
    }
  }),
  { name: "CartInfo" }
);

const CartInfoCustomer: React.FC<ICartInfo> = ({ data }) => {
  const classes = useStyles();

  return (
    <>
      <Paper className={classes.root}>
        <div className={classes.left}>
          <MyTypography variant="h6" className={classes.title}>
            <FormattedMessage defaultMessage="Contract" />
          </MyTypography>
          <MyTypography variant="body3" className={classes.subtitle}>
            <FormattedMessage defaultMessage="รวมทั้งหมด (รายการ)" />
          </MyTypography>
          <MyTypography variant="h2" className={classes.totalNumber}>
            {data ? data.totalContracts : <Skeleton />}
          </MyTypography>
        </div>
        <div className={classes.right}>
          <img src={cart1} alt="cart-icon" />
        </div>
      </Paper>

      <Paper className={classes.root}>
        <div className={classes.left}>
          <MyTypography variant="h6" className={classes.title}>
            <FormattedMessage defaultMessage="สินค้าในตะกร้า" />
          </MyTypography>
          <MyTypography variant="body3" className={classes.subtitle}>
            <FormattedMessage defaultMessage="รวมทั้งหมด (รายการ)" />
          </MyTypography>
          <MyTypography variant="h2" className={classes.totalNumber}>
            {data ? data.totalProducts : <Skeleton />}
          </MyTypography>
        </div>
        <div className={classes.right}>
          <img src={cart2} alt="cart-icon" />
        </div>
      </Paper>
    </>
  );
};

export default CartInfoCustomer;
